// Update the product page's qty input min/step/value when the selected
// variant changes. The theme dispatches `variant:updated` with detail.variant
// from its variant picker; that variant object doesn't carry metafields,
// so we read the per-variant MOQ from a JSON map rendered by
// _quantity-selector.liquid at page load.

(function () {
  if (window.__hdtMoqOnVariantInit) return;
  window.__hdtMoqOnVariantInit = true;

  function readMoqMap() {
    const map = new Map();
    document.querySelectorAll('[data-hdt-moq-map]').forEach((el) => {
      try {
        const raw = el.getAttribute('data-hdt-moq-map') || '';
        if (!raw) return;
        const obj = JSON.parse(raw);
        Object.keys(obj).forEach((k) => map.set(String(k), obj[k]));
      } catch (_) { /* ignore */ }
    });
    return map;
  }

  function snapUp(n, step) {
    if (step <= 1) return Math.max(1, n);
    return Math.ceil(n / step) * step;
  }

  function applyMoq(sectionId, variantId) {
    const wrapper = document.getElementById('Quantity-Form-' + sectionId);
    if (!wrapper) return;
    const input = wrapper.querySelector('input.hdt-quantity__input');
    if (!input) return;

    const map = readMoqMap();
    const moq = map.get(String(variantId)) || { min: 1, inc: 1, max: null };
    const min = Math.max(1, parseInt(moq.min, 10) || 1);
    const inc = Math.max(1, parseInt(moq.inc, 10) || 1);

    input.min = String(min);
    input.step = String(inc);
    let current = parseInt(input.value, 10) || min;
    if (current < min) current = min;
    if (inc > 1) current = snapUp(current, inc);
    if (moq.max && current > moq.max) current = moq.max;
    input.value = String(current);

    // Update the tooltip content under the (i) badge.
    const info = document.getElementById('Quantity-Rules-' + sectionId);
    if (info) {
      const tip = info.querySelector('.hdt-moq-info__tip');
      if (tip) {
        const parts = [];
        if (inc > 1) parts.push('In multiples of ' + inc);
        if (min > 1) parts.push('Minimum ' + min);
        if (moq.max) parts.push('Maximum ' + moq.max);
        if (parts.length === 0) {
          info.hidden = true;
        } else {
          info.hidden = false;
          tip.innerHTML = parts.map((p) => '<span class="hdt-moq-info__line">' + p + '</span>').join('');
        }
      }
    }
  }

  function onVariantUpdated(e) {
    const variant = (e.detail && e.detail.variant) || null;
    if (!variant || !variant.id) return;
    // Defer slightly so the theme's own handlers (which may reset min/value)
    // have finished running before we apply the variant-specific MOQ.
    const variantId = variant.id;
    setTimeout(() => {
      document.querySelectorAll('[id^="Quantity-Form-"]').forEach((el) => {
        const sid = el.id.replace('Quantity-Form-', '');
        applyMoq(sid, variantId);
      });
    }, 30);
  }

  // The theme dispatches `variant:change` on swatch interaction and
  // `variant:updated` elsewhere — listen to both. Bubble phase so we run
  // after the theme's own handlers (which may reset min/step).
  document.addEventListener('variant:change', onVariantUpdated, false);
  document.addEventListener('variant:updated', onVariantUpdated, false);

  // Snap-on-blur: if the customer types a qty below the variant's MOQ or off
  // its qty_increment, raise it to the next valid multiple when the input
  // commits (blur / Enter / step button release).
  function snapToBounds(input) {
    if (!input) return;
    // Honor the input's own declared minimum. Bundle-component rows in a
    // pick-one group render min="0" so the customer can set an option back
    // to 0 to skip it; standard product qty inputs declare min="1". Only
    // fall back to 1 when no valid min is present.
    let min = parseInt(input.min, 10);
    if (isNaN(min) || min < 0) min = 1;
    const step = Math.max(1, parseInt(input.step, 10) || 1);
    const maxAttr = parseInt(input.max, 10);
    let cur = parseInt(input.value, 10);
    if (isNaN(cur)) cur = min;
    if (cur < min) cur = min;
    if (step > 1) {
      const over = cur % step;
      if (over !== 0) cur = cur + (step - over);  // snap UP to next valid
    }
    if (!isNaN(maxAttr) && cur > maxAttr) cur = maxAttr;
    if (String(cur) !== input.value) input.value = String(cur);
  }

  // Attach via event delegation so dynamically-added qty inputs (e.g. sticky
  // ATC, quick view modal) get the same behaviour without re-binding.
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.classList && t.classList.contains('hdt-quantity__input')) {
      snapToBounds(t);
    }
  }, true);

  // Click/tap toggle for the (i) badge — useful on touch devices where
  // :hover/:focus alone don't keep the tooltip open.
  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest && e.target.closest('.hdt-moq-info');
    if (btn) {
      const open = btn.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Close any sibling info badges.
      document.querySelectorAll('.hdt-moq-info.is-open').forEach((other) => {
        if (other !== btn) { other.classList.remove('is-open'); other.setAttribute('aria-expanded', 'false'); }
      });
      return;
    }
    // Tap outside any badge → close all.
    document.querySelectorAll('.hdt-moq-info.is-open').forEach((b) => {
      b.classList.remove('is-open');
      b.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hdt-moq-info.is-open').forEach((b) => {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
